import { render, staticRenderFns } from "./ShopOwnerSummary.vue?vue&type=template&id=49377bb5&scoped=true&"
import script from "./ShopOwnerSummary.vue?vue&type=script&lang=ts&"
export * from "./ShopOwnerSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ShopOwnerSummary.vue?vue&type=style&index=0&id=49377bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49377bb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VRow,VSelect})
